<template lang="pug">
#layout(:class='name')
  .wrapper.centered
    .main-panel(:class="{ 'loading' : loading }")
      .navless-layout-wrapper
        .navless-layout-header
          .container-fluid
            a.logo(href='javascript:;')
              img(src='~images/../logo-default.svg', height='48')
            span.navless-page-name
              h2 {{ pageName || description }}
            span.navless-page-close(@click='cleanup')
              router-link(v-if='$routerHistory.hasHistory() && !isBackTo' :to='{ path: source, hash: "" }')
                | {{ $t('Close') }} &nbsp;
                i.fal.fa-times-circle
              a(v-if='isBackTo' @click='goBack' href='javascript:;')
                i.fal.fa-caret-circle-left &nbsp;
                | {{ $t('Back') }}
        .row.navless-main-body-wrapper
          .container-fluid
            .navless-main-body.col-md-12
              slot
      md-footer
</template>

<script>

import MdFooter from '@/components/Footer'
import Modules from '@/components/_modules'

const backToMap = {
  'EnvelopeApprovalDashboard': '/ApprovalDashboard'
}

export default {
  components: {
    MdFooter
  },

  data() {
    return {
      name: 'layout-navless',

      source: null,
      description: '',
      isBackTo: backToMap[this.$route.params.page]
    }
  },

  computed: {
    loading() {
      return this.$loading
    },

    pageName() {
      const layout = this
      let page = ''

      if (this.$route.params.section &&
        Modules[this.$route.params.page + '/' + this.$route.params.section]
      ) {
        page = Modules[this.$route.params.page + '/' + this.$route.params.section]
      } else {
        page = Modules[this.$route.params.page]
      }

      if (page) {
        // When module is async, set description after load
        if (page.module &&
            typeof page.module === 'function' &&
            this.$route.params.action &&
            Modules[this.$route.params.section + '/' + this.$route.params.action]
        ) {
          Modules[this.$route.params.section + '/' + this.$route.params.action]().then((v) => {
            if (v) {
              layout.description = v.description
            }
          })
        }

        return (
                (page.module && typeof page.module !== 'function' && ' ') ||
                (page.module && page.module.description) ||
                (page.module && typeof page.module === 'function' ? '' : '')
        )
      } else {
        return ''
      }
    }
  },

  created () {
    if (this.$route.params.page && this.$route.params.section && this.$route.params.action) {
      this.$routerHistory.save([
        '/' + this.$route.params.namespace + '/' + this.$route.params.page + '/' + this.$route.params.section + '/',
        '/' + this.$route.params.namespace + '/' + this.$route.params.page + '/' + this.$route.params.section + '/' + this.$route.params.action
      ])
    }
    this.source = this.$route.query['back-to'] || this.$routerHistory.previous().path
  },

  methods: {
    cleanup: function () {
      // this.description = ''
      this.$destroy()
    },
    goBack: function (e) {
      e.preventDefault()
      const page = this.$route.params.page
      if (backToMap[page]) {
        window.location.href = `${this.api.env}${backToMap[page]}`
      }
      return false
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

body {
  @include theme() { background: v(background) }
  height: 100vh;
}

body .navless-layout-wrapper,
body .navless-main-body-wrapper {
  min-height: 100%;
  padding: 0;
}

.main-panel .content.module {
  min-height: calc(100% - 123px);
}

.logo {
  display: inline-block;
  padding-bottom: .75rem;
  min-height: 50px;
  background-position: 10px 100%;
  margin-top: 14px;
}

.container-fluid {
  position: relative;
}

.navless-layout-wrapper {
  @include theme() { background: v(canvas) }
  padding-bottom: 1rem;
  //height: 100vh;

  .navless-layout-header {
    padding: $side-padding;
    position: relative;
    height: 5rem;

    .navless-page-name {
      display: inline-block;
      position: absolute;
      left: 11rem;
      top: 1.2rem;

      h2 {
        margin: 0;
        font-size: $font-size-large;
      }
    }

    @include theme() {
    background: v(primary-04);
    color: v(canvas);
    }

    .navless-page-close {
      text-align: right;
      position: absolute;
      right: $side-padding;
      bottom: 1.7rem;
      text-transform: uppercase;
      font-size: $font-size-xsmall;

      a {
        @include theme() { color: v(canvas) }
        transition: all .2s ease-in-out;
        &:hover {
          opacity: .3;
          text-decoration: none;
        }
        i {
          font-size: $font-size-xlarge;
          margin-left: .1rem;
          vertical-align: middle;
          margin-top: -0.15rem;
        }
      }
    }
  }
}

.navless-main-body-wrapper {
  margin: 0;
}

.navless-main-body {
  @include theme() { background: v(canvas) }
  padding: 0rem 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Layouts/navless.vue